"use client";

import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import {
  DividendBoardType,
  getDividendOptionsMap,
} from "../data/dividend-options";

type Props = ComponentProps<"select">;

export const DividendSelect = ({ ...props }: Props) => {
  const { t } = useLang();
  const { updateQuery } = useUpdateQuery();
  const optionsMap = getDividendOptionsMap({ t });
  const options = Object.values(optionsMap);

  return (
    <select
      onChange={(e) => {
        updateQuery({
          name: "dividend",
          value:
            Object.keys(optionsMap).find(
              (key) => optionsMap[key as DividendBoardType] === e.target.value
            ) ?? "dividend",
        });
      }}
      {...props}
      className={twMerge(
        "block w-full rounded-md border-gray-300 focus:border-sky-600 focus:ring-sky-600 @lg:hidden @lg:max-w-[220px]",
        props.className
      )}
    >
      {options.map((option) => (
        <option key={option}>{option}</option>
      ))}
    </select>
  );
};
